import {EditContacts} from '../widgets';
import {connect} from 'react-redux';
import actions from './profile.actions';
import {uiActions} from '../chrome';

const {persistContacts} = actions;

const ConnectedEditContacts = connect(
	({profile}) => ({
		contacts: profile && profile.editingContacts
	}),
	dispatch => ({
		onChange: (type, detail) => dispatch(actions.profileChangeEditContacts({type, detail})),
		onSave: () => {
			dispatch(actions.persistContacts());
			dispatch(uiActions.uiModal(null));
		},
		onCancel: () => dispatch(uiActions.uiModal(null))
	})
)(EditContacts);

export default ConnectedEditContacts;



// WEBPACK FOOTER //
// ./src/profile/ProfileEditContacts.js